import { DocumentInstancePermissions } from './documentInstance.permissions';
import { DocumentInstanceRoles } from './documentInstance.roles';

export const documentInstanceMappings = {
  [DocumentInstancePermissions.GET_DOCUMENT_INSTANCES]: [
    DocumentInstanceRoles.VIEWER,
  ],
  [DocumentInstancePermissions.CREATE_DOCUMENT_INSTANCE]: [
    DocumentInstanceRoles.CREATOR,
  ],
  [DocumentInstancePermissions.ARCHIVE_DOCUMENT_INSTANCE]: [
    DocumentInstanceRoles.ARCHIVER,
  ],
  [DocumentInstancePermissions.UPDATE_DOCUMENT_INSTANCE]: [
    DocumentInstanceRoles.UPDATER,
  ],
};
